import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-4 py-24 text-center" data-testid="payment-cancel">
      <XCircle className="mx-auto text-zinc-500" size={52} />
      <h1 className="font-display text-3xl font-extrabold text-white mt-4">Payment cancelled</h1>
      <p className="text-zinc-400 mt-2">Your cart is still saved. You can try checking out again whenever you're ready.</p>
      <div className="flex gap-3 justify-center mt-8">
        <Link to="/checkout"><Button className="bg-[#ff6a13] hover:bg-[#ff8a3d] rounded-full font-semibold">Back to Checkout</Button></Link>
        <Link to="/"><Button variant="outline" className="rounded-full border-zinc-700 bg-transparent text-white hover:bg-zinc-900">Home</Button></Link>
      </div>
    </div>
  );
}
